// Site fonts are self-hosted (Instrument Serif, Mabry, JetBrains Mono).
// Do not import legacy typeface packages here.

const { sanitizePagePath } = require('./src/utils/analytics');

// Gatsby browser APIs are named exports by contract.
// eslint-disable-next-line import/prefer-default-export
export const onRouteUpdate = ({ location }) => {
  if (
    process.env.NODE_ENV !== 'production'
    || typeof window === 'undefined'
    || typeof window.gtag !== 'function'
  ) {
    return;
  }

  const sendPageView = () => {
    window.gtag('event', 'page_view', {
      page_path: sanitizePagePath(location),
    });
  };

  if ('requestAnimationFrame' in window) {
    window.requestAnimationFrame(() => window.requestAnimationFrame(sendPageView));
  } else {
    window.setTimeout(sendPageView, 32);
  }
};
